import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'timeFormat',
    standalone: true
})

export class TimeFormatPipe extends DatePipe implements PipeTransform {
    override transform(value: any, args?: any): any {
        if (value === Constants.NULL_DATE || value === null || value === undefined) {
            return '';
        }

        if (typeof value === 'string' && value.match(/^\d{2}:\d{2}:\d{2}$/)) {
            const [hours, minutes, seconds] = value.split(':').map((part) => parseInt(part, 10));
            const today = new Date();
            today.setHours(hours, minutes, seconds);
            return super.transform(today, 'h:mm a'); 
        }

        return super.transform(value, Constants.TIME_FMT);
    }
}

@Pipe({
    name: 'dateFormat',
    standalone: true
})

export class DateFormatPipe extends DatePipe implements PipeTransform {
    override transform(value: any, args?: any): any {
        if (value === Constants.NULL_DATE || value === null || value === undefined) {
            return '';
        }

        return super.transform(value, Constants.DATE_FMT);
    }
}

export class Constants {
    static readonly DATE_FMT = 'dd/MM/yyyy';
    static readonly TIME_FMT = 'HH:mm';
    static readonly DATE_TIME_FMT = `${Constants.DATE_FMT} ${Constants.TIME_FMT}`;
    static readonly NULL_DATE = '0001-01-01T00:00:00';
}